module.exports = __webpack_public_path__ + "static/media/jamie-photoshoot.7a7a9cdd.png";